import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.imageSlider__container': {
		position: 'relative',
		marginBottom: remCalc(50),
		'&.padding-normal': {
			paddingTop: remCalc(30),
			paddingBottom: remCalc(30),
			[theme.breakpoints.up('sm')]: {
				paddingTop: remCalc(80),
				paddingBottom: remCalc(80),
			},
			'.imageSlider__pagination': {
				bottom: remCalc(78),
				[theme.breakpoints.up('lg')]: {
					bottom: remCalc(175),
				},
			}
		},
		'&.margin-flush': {
			marginBottom: 0,
		},
		'.imageSlider__title_section': {
			marginBottom: remCalc(80),
			'.imageSlider__title_container': {
				textAlign: 'center',
				display: 'flex',
				gap: remCalc(40),
				flexDirection: 'column',
				'.imageSlider__title': {
					textTransform: 'uppercase',
				},
				'.imageSlider__description': {
					fontWeight: 500,
				},
				'.imageSlider__title__link': {
					display: 'inline-flex',
				}
			}
		},
		'.imageSlider': {
			aspectRatio: '0.87/1',
			[theme.breakpoints.up('lg')]: {
				aspectRatio: '1.78/1',
			},
			'.imageSlider__slide': {
				'.imageSlider__inner': {
					height: '100%',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					width: '100%',
					alignItems: 'flex-end',
					justifyContent: 'flex-start',
					'.imageSlider__grid': {
						width: '100%',
						paddingBottom: remCalc('75'),
						'.imageSlider__content_container': {
							display: 'flex',
							gap: remCalc(8),
							flexDirection: 'column',
							[theme.breakpoints.up('lg')]: {
								gap: remCalc(25),
							},
							'.imageSlider__subtitle': {
								color: 'white',
								textShadow: '0 0 4px rgba(0, 0, 0, 0.15)',
								fontFamily: 'var(--heading-font)',
								fontSize: remCalc('20'),
								fontStyle: 'normal',
								fontWeight: '420',
								lineHeight: remCalc('26'),
								letterSpacing: remCalc('-0.25'),
								textTransform: 'uppercase',
								margin: '0',
								[theme.breakpoints.up('lg')]: {
									fontSize: remCalc('25'),
									lineHeight: remCalc('32'),
								},
							},
							'.imageSlider__title': {
								color: 'white',
								textShadow: '0 0 4px rgba(0, 0, 0, 0.15)',
								fontFamily: 'var(--heading-font)',
								fontSize: remCalc('32'),
								fontStyle: 'normal',
								fontWeight: '420',
								lineHeight: remCalc('40'),
								letterSpacing: remCalc('0.5'),
								textTransform: 'uppercase',
								margin: '0',
								[theme.breakpoints.up('lg')]: {
									fontSize: remCalc('61'),
									lineHeight: remCalc('67'),
								},
							}
						},
						'.imageSlider__link_holder': {
							display: 'flex',
							alignItems: 'flex-end',
							justifyContent: 'flex-end',
							[theme.breakpoints.up('lg')]: {
								gridColumn: '13 / 14',
							},
							'.imageSlider__link': {
							    display: 'flex',
								// backgroundColor: 'blue',
								alignItems: 'center',
								justifyContent: 'center',
								borderRadius: '100%',
								height: remCalc('40'),
								width: remCalc('40'),
								backgroundColor: 'white',
								color: getColor('ivory', 800),
								'svg': {
									height: remCalc('15'),
									width: remCalc('15'),
								},
								[theme.breakpoints.down('sm')]: {
									position: 'absolute',
									top: remCalc(30),
									right: remCalc(20),
								},
								[theme.breakpoints.up('lg')]: {
									...theme.mixins.glass,
									height: remCalc('52'),
									width: remCalc('52'),
									color: 'white',
									'svg': {
										height: remCalc('20'),
										width: remCalc('20'),
									},
									'&:hover': {
										backgroundColor: 'white',
										color: getColor('ivory', 800),
									}
								}
							}
						}
					}
				}
			},
		},
		'&.fullwidth-layout': {
			'.imageSlider': {
				[theme.breakpoints.up('xl')]: {
					maxWidth: remCalc('2000px'),
					aspectRatio: '2.1/1',
				},
			}
		},
		'&.gallery-layout': {
			'.imageSlider': {
				aspectRatio: 'unset',
				[theme.breakpoints.up('xl')]: {
					maxWidth: remCalc('2000px'),
				},
				'.imageSlider__slide': {
					'.imageSlider__gallery_slide__inner': {
						display: 'flex',
						alignItems:'flex-start',
						justifyContent:'center',
						flexDirection:'column',
						transition: 'all .2s',
						padding: 0,
						'.imageSlider__gallery_slide__background': {
							aspectRatio: '2.25/1',
							marginBottom: remCalc('40'),
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							width: '100%',
						},
						'.imageSlider__gallery_slide__grid': {
							opacity: '0',
							transition: 'all .2s',
							width: '100%',
							'.imageSlider__content_container': {
								textAlign: 'center',
								[theme.breakpoints.up('md')]: {
									textAlign: 'left',
								},
								'.imageSlider__title': {
									color: getColor('ivory', 700),
									fontFamily: 'var(--heading-font)',
									fontSize: remCalc(26),
									fontWeight: '400',
									lineHeight: remCalc(32),
									letterSpacing: '-0.01625rem',
									textTransform: 'uppercase',
									margin: '0',
									marginBottom: remCalc('10'),
									[theme.breakpoints.up('md')]: {
										fontSize: remCalc(39),
										lineHeight: remCalc(47),
										letterSpacing: '0.03125rem',
										margin: '0',
									},
								},
								'.imageSlider__subtitle': {
									color: getColor('ivory', 600),
									fontFamily: 'var(--heading-font)',
									fontSize: remCalc(20),
									fontStyle: 'italic',
									fontWeight: '400',
									lineHeight: remCalc(26),
									letterSpacing: '0.03125rem',
									textTransform: 'lowercase',
									'&.imageSlider__subtitle--normal': {
										textTransform: 'none',
									},
									margin: '0',
									[theme.breakpoints.up('md')]: {
										fontSize: remCalc(25),
										lineHeight: remCalc(26),
										letterSpacing: '-0.015625rem',
									},
								}
							},
							'.imageSlider__link_holder': {
								textAlign:'right',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								[theme.breakpoints.up('md')]: {
									justifyContent: 'flex-end',
								},
								'.imageSlider__link': {
									color: getColor('ivory', 700),
									fontFamily: 'var(--heading-font)',
									fontSize: remCalc(16),
									fontStyle: 'normal',
									fontWeight: '400',
									lineHeight: remCalc(20),
									letterSpacing: remCalc('2'),
									textTransform: 'uppercase',
									margin: '0',
									textDecoration: 'none',
									position: 'relative',
									display: 'inline-flex',
									flexDirection: 'column',
									gap: remCalc(7),
									[theme.breakpoints.up('md')]: {
										fontSize: remCalc(20),
										lineHeight: remCalc(24),
										letterSpacing: remCalc('2'),
									},
									'&:after': {
										content: '""',
										width: '100%',
										height: remCalc('1'),
										backgroundColor: getColor('ivory', 700),
									}
								}
							}
						}
					},
					'&.swiper-slide-active': {
						'.imageSlider__gallery_slide__inner': {
							'.imageSlider__gallery_slide__grid': {
								opacity: '1',
							}
						}
					},
					'&.swiper-slide-prev': {
						'.imageSlider__gallery_slide__inner': {
							[theme.breakpoints.up('md')]: {
								paddingRight: remCalc(84),
							}
						}
					},
					'&.swiper-slide-next': {
						'.imageSlider__gallery_slide__inner': {
							[theme.breakpoints.up('md')]: {
								paddingLeft: remCalc(84),
							}
						}
					}
				}
			}
		},
		'&.gallery-fade-layout': {
			paddingBottom: remCalc(90),
			[theme.breakpoints.up('sm')]: {
				paddingBottom: remCalc(110),
			},
			'.imageSlider__galleryFade': {
				margin: 0,
				'.imageSlider__galleryFade_slide': {
					'.imageSlider__galleryFade_slide_background': {
						aspectRatio: '1.78/1',
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover',
						backgroundPosition: 'center center'
					}
				},
				'.imageSlider__galleryFade_navigation': {
					position: 'absolute',
					left: remCalc(40),
					right: remCalc(40),
					top: 0,
					bottom: 0,
					zIndex: 2,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					margin: 'auto 0',
					gap: remCalc(10),
					[theme.breakpoints.down('ms')]: {
						display: 'none',
					},
					'button': {
						display: 'flex',
						width: remCalc(52),
						height: remCalc(52),
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						gap: remCalc(10),
						aspectRatio: '1 / 1',
						border: 'none',
						borderRadius: remCalc(6),
						...theme.mixins.glass,
						transition: 'all .2s',
						'svg': {
							color: getColor('white'),
							width: remCalc(23),
						},
						[theme.breakpoints.up('lg')]: {
							'&:hover': {
								cursor: 'pointer',
								background: 'rgba(255, 255, 255, 0.35)',
								boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
								backdropFilter: 'blur(15px)',
							}
						}
					}
				},
				'.imageSlider__galleryFade_bullets': {
					position: 'absolute',
					bottom: remCalc(17),
					display: 'flex',
					flexDirection: 'row',
					transition: '300ms opacity',
					transform: 'translate3d(0, 0, 0)',
					zIndex: '10',
					width: '100%',
					paddingLeft: remCalc(17),
					paddingRight: remCalc(17),
					[theme.breakpoints.up('ms')]: {
						display: 'none',
					},
					'.imageSlider__galleryFade_bullet': {
						flex: 'auto',
						height: remCalc(4),
						background: 'rgba(255, 255, 255, 0.40)',
						transition: 'all .2s',
						border: 'none',
						[theme.breakpoints.up('lg')]: {
							'&:hover': {
								cursor: 'pointer',
							}
						},
						'&.imageSlider__galleryFade_bullet-active': {
							background: 'white',
						}
					}
				},
			}
		},
		'.imageSlider__pagination': {
			bottom: remCalc(48),
			position: 'absolute',
			width: '100%',
			[theme.breakpoints.up('lg')]: {
				bottom: remCalc(75),
			},
			'.imageSlider__bullets': {
				display: 'flex',
				flexDirection: 'row',
				transition: '300ms opacity',
				transform: 'translate3d(0, 0, 0)',
				zIndex: '10',
				'.imageSlider__bullet': {
					flex: 'auto',
					height: remCalc(4),
					background: 'rgba(255, 255, 255, 0.40)',
					transition: 'all .2s',
					border: 'none',
					[theme.breakpoints.up('lg')]: {
						'&:hover': {
							cursor: 'pointer',
						}
					},
					'&.imageSlider__bullet-active': {
						background: 'white',
					}
				}
			}
		},
	},
}

const styles = {};

export default styles;